import { Routes, Route, Navigate, useLocation } from 'react-router-dom';

import Login from '../pages/login/Login';
import Registrar from '../pages/Registrar/Registrar';
import Eventos from '../pages/Eventos/Eventos';
import PerfilEstablecimiento from '../pages/PerfilEstablecimiento/PerfilEstablecimiento';
import Inventario from '../pages/Inventario/Inventario';
import RutaProtegida from './rutaProtegida';
import Menu from '../Component/Menu/Menu';
import BarCard from '../Component/header/BarCard';
import { useEffect, useState } from 'react';
import Music from '../pages/music/Music';
import BuscarCancion from '../pages/Eventos/BuscarCancion';
import Restablecer from '../pages/Restablecer/Restablecer';
import bg from '../../src/assets/image/background.jpeg'

export default function Navegacion() {
  const location = useLocation(); // Detecta cambios de ruta
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  // Se actualiza cada vez que cambia la ruta
  useEffect(() => {
    const token = localStorage.getItem('access');
    setIsAuthenticated(!!token);
  }, [location])
  return (
    <>
      <div className={ isAuthenticated ? `flex min-h-screen w-screen bg-gray-800 `:''}>
        {/* <Menu /> */}
        {isAuthenticated && !location.pathname.startsWith('/Music') && !location.pathname.startsWith('/BuscarCancion') && <Menu />}
        <div style={{backgroundImage: `url(${bg})`, position:'absolute', height:'100%', width:'100%'}} className={ isAuthenticated ? `flex flex-col flex-1 pl-20 ${!location.pathname.startsWith('/Music') ? 'bg-white':''}  p-6`: ''} >
          {isAuthenticated  && !location.pathname.startsWith('/Music') && <BarCard />}
          <Routes>
            <Route path="/" element={<Login />} />
            <Route path="/BuscarCancion/:query" element={<BuscarCancion />} />
            <Route path="/Registrar" element={<Registrar  />} />
            <Route path="/RestablecerCon" element={<Restablecer  />} />
              <Route path="/Eventos" element={
                <RutaProtegida>
                    <Eventos />
                  </RutaProtegida>
                } />
            <Route path="/Perfil" element={
              <RutaProtegida>
                <PerfilEstablecimiento />
              </RutaProtegida>
              } />
            <Route path="/Inventario" element={
                <RutaProtegida>
                  <Inventario />
                </RutaProtegida>
              } />
              <Route path="/Music" element={
                <RutaProtegida>
                  <Music />
                </RutaProtegida>
              } />
            {/* Redireccionar a paso 1 si la ruta no existe */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </div>
      </div>
    </>
  );
}
